<template>
  <div class="sib-arrow" :class="classes" :style="styleOpject">
    <div class="sib-arrow__piece sib-arrow__piece-left"></div>
    <div class="sib-arrow__piece sib-arrow__piece-right"></div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from '@vue/reactivity'
import { CSSProperties } from 'vue'

interface CSSPropertiesWithVars extends CSSProperties {
  [key: string]: string | number | undefined
}

const props = withDefaults(
  defineProps<{ type?: string; arrowWidth?: string; arrowHeight?: string }>(),
  {
    type: 'up',
    arrowWidth: '0.85em',
    arrowHeight: '1px',
  }
)
const classes = computed(() =>
  props.type == 'up' ? 'sib-arrow--up' : 'sib-arrow--down'
)
const styleOpject = computed(() => {
  const result: CSSPropertiesWithVars = {}
  if (props.arrowWidth) {
    result['--sib-arrow-width'] = props.arrowWidth
  }
  if (props.arrowHeight) {
    result['--sib-arrow-height'] = props.arrowHeight
  }
  return result
})
</script>

<style lang="scss">
.sib-arrow {
  --sib-arrow-width: 0.85em;
  --sib-arrow-height: 2px;
  --animation-duration: 0.3s;
  --animation-delay: 0.4s;
  cursor: pointer;
  width: var(--sib-arrow-width);
  height: var(--sib-arrow-width);
  position: relative;
  $rotate: 45;
  $translateX: 10.3553 + 0.2; // (sqrt(2) - 1)/4 + 0.2
  $sqrt2: 1.4142135623730951; // sqrt(2)

  &__piece {
    --piece-animation-delay: var(--animation-delay);
    --translateX: 0;
    --translateY: 0;
    --rotate: 0;
    width: calc(var(--sib-arrow-width) / #{$sqrt2});
    height: var(--sib-arrow-height);
    background: currentColor;
    position: absolute;
    top: 50%;
    transform-origin: center;
    transform: translate3d(var(--translateX), var(--translateY), 0)
      rotate(var(--rotate));
    transition: transform var(--animation-duration) var(--piece-animation-delay)
      ease-in-out;

    &-left {
      left: 0;
      --translateX: -#{$translateX}%;
      --rotate: #{$rotate}deg;
    }

    &-right {
      right: 0;
      --piece-animation-delay: calc(
        var(--animation-delay) + var(--animation-duration) * 0.75
      );
      --translateX: #{$translateX}%;
      --rotate: -#{$rotate}deg;
    }
  }

  &--up {
    .sib-arrow__piece {
      &-left {
        --rotate: -#{$rotate}deg;
      }

      &-right {
        --rotate: #{$rotate}deg;
      }
    }
  }
}
</style>
